module.exports = __webpack_public_path__ + "img/536258179.4f018d8e.jpg";